module.exports = __webpack_public_path__ + "static/img/0.6a5c35f.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/loading/img/0.png
// module id = 9eJh
// module chunks = 0